package com.wintermar.inspection.feature.presentation.inspection.answer.widget.finding_category

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import com.wintermar.inspection.core.ui.util.SelectionModel
import com.wintermar.inspection.graphql.type.FindingCategory

@Composable
actual fun FindingCategoryModal(
    show: Boolean,
    title: String,
    selectedFindingCategory: FindingCategory?,
    referenceItems: List<SelectionModel>,
    onDismiss: () -> Unit,
    onSelectedFindingCategory: (FindingCategory) -> Unit
) {
    ModalDialog(
        show = show,
        title = title,
        action = ModalAction.default().copy(
            withBackgroundHeader = true
        ),
        onDismiss = onDismiss
    ) {
        FindingCategoryContent(
            selectedFindingCategory = selectedFindingCategory,
            referenceItems = referenceItems,
            onSelectedFindingCategory = onSelectedFindingCategory
        )
    }
}
